import {useEffect, useState} from "react";
import useCountryAxiosInstance from "../hooks/useCountryAxiosInstance";
import {CROP_ASPECT_RATIO} from "../utils/constants";
import Spinner from "@ui-components/Spinner";


const PrivateImage = ({
    image_url,
    className,
    tag,
    onRetrievedSignedURL = () => {},
    loadedOn=null,
    fixedAspectRatio=true,
    bucket="worksite_images",
    sign=true,
    aspectRatio=CROP_ASPECT_RATIO,
    ...rest
}) => {

  const [signedImageUrl, setSignedImageUrl] = useState(null);
  const apiRequest = useCountryAxiosInstance()
  const srcInvalidator = loadedOn ? `&tms=${loadedOn.getTime()}` : '';

  useEffect(() => {

    if (!sign) {
      setSignedImageUrl(image_url)
      return;
    }

    const fetchSignedUrl = async () => {
      if (!image_url)
        return;

      try {
        const url = await apiRequest.post(`/aws-signed-url`, {
          content_type: '',
          format: '',
          prefix: image_url.split(".com/").pop(),
          bucket: bucket,
          method: 'GET'
        });

        setSignedImageUrl(url)
        onRetrievedSignedURL(url)
      } catch (error) {
        console.log("errore", error);
      }
    }
    fetchSignedUrl();
    //  eslint-disable-next-line
  }, [image_url]);

  if (!signedImageUrl) {
    return null;
  }
  if (tag === 'div') {
    return (
      <div
        className={className}
        style={{
          backgroundImage: `url(${signedImageUrl}${srcInvalidator})`,
          backgroundSize: 'cover',
          ...(fixedAspectRatio ? {aspectRatio: aspectRatio.toString(), height: 'auto'} : {})
        }}
        {...rest}
      />
    )
  } else if (tag === 'img') {
    return (
      <img
        src={signedImageUrl + srcInvalidator}
        alt={signedImageUrl}
        style={{
          maxWidth: "100%",
          height: "auto",
          ...(fixedAspectRatio ? {aspectRatio: aspectRatio.toString()} : {})
        }}
        {...rest}
      />
    )
  }
}
export default PrivateImage;